import { Grid } from '@material-ui/core';
import { Panel } from '@michelin/acid-components';
import React, { forwardRef, useEffect, useImperativeHandle, } from 'react';
import { useForm, } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormField } from '../Form/FormField';
import { useBOVehicleDetailsFormContext } from './BOVehicleDetailsFormContext';
import { BOVehicleDetailsKey } from './types';
var FormComponent = function (props, ref) {
    var onSubmit = props.onSubmit, onValidationFailed = props.onValidationFailed, defaultValues = props.defaultValues, readOnly = props.readOnly, mode = props.mode, onDirtyStateChanged = props.onDirtyStateChanged, optionalOption = props.optionalOption;
    var _a = useBOVehicleDetailsFormContext(), values = _a.values, load = _a.load, loading = _a.loading;
    var t = useTranslation().t;
    var _b = useForm({
        defaultValues: defaultValues,
        mode: 'onChange',
    }), register = _b.register, _c = _b.formState, errors = _c.errors, isDirty = _c.isDirty, handleSubmit = _b.handleSubmit, control = _b.control, reset = _b.reset, watch = _b.watch, setValue = _b.setValue;
    var tireSize = watch('tire_size_id');
    var customTireSize = watch('tire_size_id');
    var vin = watch('vin');
    if (!tireSize && customTireSize)
        setValue('tire_size_id', 'custom');
    var onValid = function (data) {
        if (!readOnly && onSubmit) {
            onSubmit(data);
        }
    };
    var onInvalid = function (err) {
        if (!readOnly && onValidationFailed) {
            onValidationFailed(err);
        }
    };
    useImperativeHandle(ref, function () { return ({
        submit: function () {
            handleSubmit(onValid, onInvalid).bind(this)();
        },
        reset: function () {
            reset();
        },
    }); });
    useEffect(function () {
        if (onDirtyStateChanged) {
            onDirtyStateChanged(isDirty);
        }
    }, [isDirty]);
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Panel, { title: t('Vehicle Information'), style: { marginBottom: 16 } },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3, lg: 3 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.year,
                                label: t('Year'),
                                options: values.years,
                                loading: loading.years,
                                helperText: t('Year is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.year], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.make,
                                label: t('Make'),
                                options: values.makes,
                                loading: loading.makes,
                                helperText: t('Make is required'),
                                dependencies: [BOVehicleDetailsKey.year],
                                onDependenciesChanged: load.makes,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.make], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.model,
                                label: t('Model'),
                                options: values.models,
                                loading: loading.models,
                                helperText: t('Model is required'),
                                dependencies: [BOVehicleDetailsKey.year, BOVehicleDetailsKey.make],
                                onDependenciesChanged: load.models,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.model], readOnly: readOnly, register: register, control: control })),
                    load.options && (React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.option,
                                label: t('Option'),
                                options: values.options,
                                loading: loading.options,
                                helperText: !optionalOption ? t('Option is required') : '',
                                dependencies: [BOVehicleDetailsKey.year, BOVehicleDetailsKey.make, BOVehicleDetailsKey.model],
                                onDependenciesChanged: load.options,
                                rules: {
                                    required: !optionalOption,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.option], readOnly: readOnly, register: register, control: control }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3, lg: 3 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.assetType,
                                label: t('Asset Type'),
                                options: values.assetTypes,
                                loading: loading.assetTypes,
                            }, error: !!errors[BOVehicleDetailsKey.assetType], readOnly: readOnly, register: register, control: control }))))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Panel, { title: t('Vehicle Details'), style: { marginBottom: 16 } },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.vehicleUnitNumber,
                                label: t('Vehicle Unit Number'),
                                helperText: t('Vehicle Unit Number is required'),
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.vehicleUnitNumber], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.licensePlate,
                                label: t('License Plate Number'),
                                helperText: t('License Plate Number is required and should be 7 characters or shorter'),
                                rules: {
                                    required: true,
                                    maxLength: 7,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.licensePlate], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4, onBlur: function () { return setValue('vin', vin.toLocaleUpperCase()); } },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.vin,
                                label: t('VIN'),
                                helperText: t('VIN is required and should be 17 characters long'),
                                rules: {
                                    required: true,
                                    minLength: 17,
                                    maxLength: 17,
                                },
                                forceUppercase: true,
                            }, error: !!errors[BOVehicleDetailsKey.vin], readOnly: readOnly || mode === 'edit', register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.licenseState,
                                label: t('License Plate State'),
                                helperText: t('License Plate State is required'),
                                options: values.states,
                                loading: loading.states,
                                rules: {
                                    required: true,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.licenseState], readOnly: readOnly, register: register, control: control })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 4, md: 4, xl: 4 },
                        React.createElement(FormField, { definition: {
                                name: BOVehicleDetailsKey.color,
                                label: t('Color'),
                                helperText: t('Color is required'),
                                rules: {
                                    required: false,
                                },
                            }, error: !!errors[BOVehicleDetailsKey.color], readOnly: readOnly, register: register, control: control })))))));
};
var BOForm = forwardRef(FormComponent);
export { BOForm };
//# sourceMappingURL=Form.js.map